module.exports = require('./helpers/bundle-url').getBundleURL('dUdTx') + "logo-dark.eefe0b7f.svg";